export const VISUAL_GALLERY_DEFAULTS = Object.freeze([
  Object.freeze({
    slot: "main",
    imageUrl: "/assets/lolaabsolut/editorial-rocks.webp",
    altText: "Woman emerging from the turquoise sea",
    caption: "Coast 02 / No filter",
    position: 0
  }),
  Object.freeze({
    slot: "top",
    imageUrl: "/assets/lolaabsolut/editorial-night-standing-square.webp",
    altText: "Two women at a neon-lit night venue",
    caption: "Night 01 / After dark",
    position: 1
  }),
  Object.freeze({
    slot: "bottom",
    imageUrl: "/assets/lolaabsolut/editorial-pool.webp",
    altText: "Woman relaxing beside vivid blue water",
    caption: "Absolut Summer 03",
    position: 2
  })
]);

export const VISUAL_GALLERY_SLOTS = Object.freeze(
  VISUAL_GALLERY_DEFAULTS.map((item) => item.slot)
);
